import { imageGenerationTourConfig } from '../tours/image-generation/image-gen-tour.config';

import type { TourConfig } from './onboarding.types';

export const TOUR_REGISTRY: TourConfig[] = [
  imageGenerationTourConfig,
  // Future tours can be added here:
  // canvasBasicsTourConfig,
];

export const ONBOARDING_STORAGE_KEY = 'onboarding_tour_states';
